export enum FinancialReceivementCardOriginEnum {
    SALE = 'Venda',
    RECEIVEMENT = 'Recebimento',
    CREDIT_CLIENT = 'Crédito do cliente'
}

export type FinancialReceivementCardOrigin = 'SALE' | 'RECEIVEMENT' | 'CREDIT_CLIENT';
